export const SITE = {
  expertName: "LONTIS NICOLAE STELIAN",
  shortName: "ETJ · Lontis",
  role: "Expert Tehnic Judiciar",
  authNumber: "3710072019",
  authSeries: "74788314062019",
  phone: "+40 721 605 655",
  phoneRaw: "+40721605655",
  email: "etj.nicolae.lontis@gmail.com",
  address: "Chișoda, str. Smochinului nr. 6",
  addressCity: "Chișoda (Timiș), România",
  whatsapp: "40721605655",
};

export const MEDIA = {
  hero: "https://static.prod-images.emergentagent.com/jobs/f642a270-7839-4456-b6dd-859f9ebac8fe/images/9a24f72c2f08fbfe6359d7e827aea572dc2b8339ecf1dba08bf450f9f82b0c20.png",
  blueprint:
    "https://static.prod-images.emergentagent.com/jobs/f642a270-7839-4456-b6dd-859f9ebac8fe/images/822dbc189905eb61b7554ae694ee2ad375b40be9c8637104aba32451dd57c63a.png",
  topo: "https://static.prod-images.emergentagent.com/jobs/f642a270-7839-4456-b6dd-859f9ebac8fe/images/f7f127eb7ac600003f7bf848c34728d2fc9c5319457708be7b493036dc4062c1.png",
  drone:
    "https://images.unsplash.com/photo-1555867358-2745816780e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxkamklMjBtYXZpYyUyMHBybyUyMGRyb25lfGVufDB8fHx8MTc3OTAxMTcxOHww&ixlib=rb-4.1.0&q=85",
  accident:
    "https://static.prod-images.emergentagent.com/jobs/f642a270-7839-4456-b6dd-859f9ebac8fe/images/b8e5b7c668346bd61c46b1f1d7d8bb9db6cf143e7c940e41111ca285e19b14e3.png",
};
